module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_02-2e2e6680f8944ad1daa2f08b23bd2463.jpg";